import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppFilter } from "../../../models/app-filter.model";
import { Observable } from "rxjs";
import { Permission } from "app/shared/auth/permission.enum";
import { AbGrupoPessoa } from "app/abstract/full-pages/grupo-pessoa/grupo-pessoa.abstract";

@Injectable({ providedIn: 'root' })
export class GrupoPessoaService extends AbGrupoPessoa {

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public desativarGrupoPessoa(id: number) {
    return this.delete("grupopessoas/desativar/", id);
  }

  public getAllGrupoPessoas(filter: AppFilter) {
    return this.get(`grupopessoas/filter/${filter.encode()}`);
  }

  public getAllGrupoAtivos() {
    return this.get(`grupopessoas/allgrupopessoas`);
  }

  public salvar(grupoPessoa): Observable<any> {
    return this.save('grupopessoas/', grupoPessoa);
  }

  public getById(id: number) {
    return this.get("grupopessoas/", id);
  }

  public getByIdForSigma(id: number) {
    return this.http.get(`${this.url}grupopessoas/${id}/true`);
  }

  public getGruposPermissao(permissao: Permission) {
    return this.get(`grupopessoas/permissao/${permissao}`);
  }

  public getGruposPermissaoPromise(permissao: Permission) {
    return this.get(`grupopessoas/permissao/${permissao}`).toPromise().catch();
  }

  public getTipoPerfis() {
    return this.get(`sigma/tipo-perfis`);
  }

  public getSigmaGrupoAcesso() {
    return this.get(`sigma/grupo-acesso`);
  }

  public getPublicSigmaGrupoAcesso() {
    return this.get(`public/sigma/grupo-acesso`);
  }

}
